import React from 'react'

const SectionHeading = ({heading, borderBottom}) => {
    const style = {
        borderBottom: borderBottom && '1px solid var(--grey-clr)',
        padding: '2em 0',
        textAlign: 'center',
        fontSize: 'var(--second-headline-fz)'
    }
    return (
        <div style={style}>
            {heading}
        </div>
    )
}

export default SectionHeading
